import { render, staticRenderFns } from "./JModal.vue?vue&type=template&id=97d66f84&scoped=true&"
import script from "./JModal.vue?vue&type=script&lang=js&"
export * from "./JModal.vue?vue&type=script&lang=js&"
import style0 from "./JModal.vue?vue&type=style&index=0&id=97d66f84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d66f84",
  null
  
)

export default component.exports